<template>
  <div>
    <slot name="default"></slot>
  </div>
</template>

<script>
export default {
  name: 'PlaceholderComponent'
}
</script>

<style scoped>

</style>
